import { create } from 'zustand';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { GetRelatedProductUsecase } from '@modules/recipes/application/usecases/getRelatedProduct.usecase';
import { IRelatedProduct } from '@shared/models/relatedProduct.model';
import { RecipeRelatedProductRepositoryImpl } from '../../inbound/repositories/relatedProduct.repository';
interface RecipeRelatedProductState {
  relatedProductList: IRelatedProduct[];
  fetchRelatedProductList: (slug: string) => void;
}
const initialState: IRelatedProduct[] = [];
export const recipeRelatedProductStore = create<RecipeRelatedProductState>(set => ({
  relatedProductList: initialState,
  fetchRelatedProductList: async (slug: string): Promise<void> => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const recipeRelatedProductRepositoryImpl = new RecipeRelatedProductRepositoryImpl();
      const getRelatedProductUsecase = new GetRelatedProductUsecase(recipeRelatedProductRepositoryImpl);
      const result = await getRelatedProductUsecase.handle(slug);
      if (result.isRight()) {
        set(() => ({
          relatedProductList: result.value
        }));
      }
    } catch (err) {
      console.error('error fetchRelatedProductList', err);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  }
}));